import { FormLabel, Grid, TextField } from "@mui/material";


export const ViewAndEditEntity = ({
  handleInputChange,
  row,
  viewMode,
  validationStatus,
}) => {
  //inline style
  const InlineStyle = {
    EntityDivison: {
      width: "230px", height: "32", padding: "0px"
    },
  }
  return (
    <form>
      <Grid container
       justifyContent={"space-between"}
       //  sx={{ width: "80%" }}
      >
        <Grid
          item
          xs={5}
          display={"flex"}
          flexDirection={"column"}
          gap={"5px"}
          mt={"20px"}
        >
          <FormLabel>Transaction Category</FormLabel>
          <TextField
            value={row.txn_category}
            onChange={(e) =>
              handleInputChange("txn_category", e.target.value)
            }
            sx={InlineStyle.EntityDivison}
            size="small"
            placeholder=""
            disabled={viewMode}
          />
          <br />
          {validationStatus?.txn_category && (
            <span style={{ color: "red" }}>
              {validationStatus?.txn_category}
            </span>
          )}
        </Grid>
        {viewMode ?
          <>
            <Grid
              item
              xs={5}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
              mt={"20px"}
            >
              <FormLabel>Created By </FormLabel>
              <TextField
                value={row.created_by}
                sx={InlineStyle.EntityDivison}
                size="small"
                placeholder=""
                disabled={viewMode}
              />
              <br />
            </Grid>
            <Grid
              item
              xs={5}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
              mt={"20px"}
            >
              <FormLabel>Updated By </FormLabel>
              <TextField
                value={row.updated_by}
                sx={InlineStyle.EntityDivison}
                size="small"
                placeholder=""
                disabled={viewMode}
              />
              <br />
            </Grid>
          </>
          : null}

      </Grid>
    </form>
  );
}